module.exports = __webpack_public_path__ + "img/ic_easy.e9a02dfa.svg";